module.exports = __webpack_public_path__ + "img/img_manual.c9d74b8c.png";